import { RumEvent } from '@datadog/browser-rum';

// Exact-path match (not a substring check) so this never swallows an unrelated
// endpoint whose URL happens to contain `/api/me` (e.g. `/api/members`, `/api/media`).
const isApiMePath = (url: string): boolean => {
    try {
        return new URL(url).pathname === '/api/me';
    } catch {
        return false;
    }
};

// The backend correctly returns 401 on `/api/me` whenever the session cookie is
// absent or expired (bootstrap probe on stale localStorage, or mid-session expiry).
// It is not an app error, so it should not flip the session into "Sessions with errors".
export const isExpectedApiMe401Error = (event: RumEvent): boolean =>
    event.type === 'error' &&
    event.error.source === 'network' &&
    event.error.resource?.status_code === 401 &&
    isApiMePath(event.error.resource.url);
